import React from 'react';

import ReactComponent from './line-pressure.svg?react';

export default function FarmbotLinePressureIcon() {
  return <ReactComponent width={18} />;
}
